import { render, staticRenderFns } from "./court-service-cn.vue?vue&type=template&id=70603ba8&"
import script from "./court-service-cn.vue?vue&type=script&lang=js&"
export * from "./court-service-cn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports